import axiosInstance from '@/axiosInterceptor';

export async function downloadPr(payload, docName) {
    await axiosInstance.post('/document/download', payload)
        .then(async (response) => {
            let presignedUrl = response.data.data.downloadUrl;
            const fileResponse = await fetch(presignedUrl);
            const blob = await fileResponse.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            let filename = `${docName}.pdf`;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            URL.revokeObjectURL(link.href);
        })
}